export enum APP_ROUTES {
  HOME = "",
  LOGIN = "/login",
  SIGN_UP = "/sign-up",
  RESET_PASSWORD = "/reset-password",
  CHANGE_PASSWORD_RESET = "/password/reset/confirm/:uid/",
  NEW_PASSWORD_REQUIRED = "/password/new/",
  CHANGE_PASSWORD = "/password/change/",
  DASHBOARD = "/dashboard",
  LATEST_UPDATES = "/latest-updates",

  COMPANIES = "/companies",
  COMPANY_COMPARATOR = "/company-comparator",
  INVESTORS = "/investors",
  FUNDING_ROUND = "/funding-round/:fundingRoundId",
  FUNDING_ROUND_NEW = "/funding-round/",
  FUNDING_ROUNDS = "/funding-rounds",
  FUNDING = "/funding/:fundingId",

  PARTNERSHIPS = "/partnerships",
  GRAPH_PARTNERSHIPS = "/partnerships/graph",
  GRAPH_PARTNERSHIPS_ENTITY = "/partnerships/graph/:entityId",

  GROUPS_AND_CENTERS = "/groups-and-centers",
  UNIVERSITIES = "/universities",

  NATIONAL_LABS = "/national-labs",

  ENTERPRISE_USERS = "/enterprise-users",

  GOVERNMENTS = "/governments",

  GOVERNMENT_FUNDINGS = "/government-fundings",
  GOVERNMENT_FUNDINGS_MAP = "/government-fundings/map",
  GOVERNMENT_FUNDING = "/government-funding/:entityId",
  GOVERNMENT_FUNDING_NEW = "/government-funding/",

  GOVERNMENT_OPPORTUNITIES_US = "/government-opportunities",
  GOVERNMENT_OPPORTUNITIES_EU = "/government-opportunities/eu",

  PARTNERSHIP = "/partnership/",
  PARTNERSHIP_EDIT = "/partnership/:partnershipId",

  REPORTS = "/reports",
  REPORTS_EXTERNAL = "/reports/external",
  INSIGHTS = "/insights",
  TAXONOMY = "/taxonomy",
  NEWS = "/news",
  FORUM = "/forum",
  OFFICE = "/office",
  PROFILE = "/profile",
  NOTIFICATION_SETTINGS = "/settings/notifications",
  COMPANY_PROFILE = "/company/:entityId/profile",
  COMPANY_FUNDING = "/company/:entityId/funding",
  COMPANY_PATENTS = "/company/:entityId/patents",
  COMPANY_CONTACTS = "/company/:entityId/contacts",
  COMPANY_FINANCIAL_DETAILS = "/company/:entityId/financial-details",
  COMPANY_FINANCIAL_DETAILS_STATEMENTS = "/company/:entityId/financial-details/statements",
  COMPANY_FINANCIAL_DETAILS_STATISTICS = "/company/:entityId/financial-details/statistics",
  COMPANY_FINANCIAL_DETAILS_GROWTH = "/company/:entityId/financial-details/growth",
  COMPANY_FINANCIAL_DETAILS_REVENUE = "/company/:entityId/financial-details/revenue",
  COMPANY_SPACE_HERITAGE = "/company/:entityId/space-heritage",

  CONSORTIUMS = "/consortiums",
  CONSORTIUMS_MAP = "/consortiums/map",
  CONSORTIUM_PROFILE = "/consortium/:entityId/profile",
  CONSORTIUM_MEMBERS = "/consortium/:entityId/members",

  INVESTOR_PROFILE = "/investor/:entityId/profile",
  INVESTOR_ARTICLE = "/investor/:entityId/articles",
  INVESTOR_SPACE_HERITAGE = "/investor/:entityId/space-heritage",

  UNIVERSITY_PROFILE = "/university/:entityId/profile",
  UNIVERSITY_SPACE_HERITAGE = "/university/:entityId/space-heritage",

  NATIONAL_LABS_PROFILE = "/national-lab/:labId/profile",

  GOVERNMENT_ENTITIES_PROFILE = "/government/:entityId/profile",
  GOVERNMENT_ENTITIES_SPACE_HERITAGE = "/government/:entityId/space-heritage",

  GROUPS_AND_CENTERS_PROFILE = "/groups-and-center/:entityId/profile",

  ENTERPRISE_USERS_PROFILE = "/enterprise-user/:entityId/profile",

  CONTACT = "/contact",
  CONFIRM_REGISTRATION = "/auth/users/activate/:uid/:token",
  SEARCH_PAGE = "/search",

  ENTITY = "/entity/:entityId",
  ENTITY_NEW = "/entity/",

  ADMIN_DASHBOARD = "/admin-dashboard",
  ADMIN_DASHBOARD_ENTITIES = "/admin-dashboard/entities",
  ADMIN_DASHBOARD_VERTICAL_PROFILES = "/admin-dashboard/vertical-profiles",
  ADMIN_DASHBOARD_ROUNDS = "/admin-dashboard/rounds",
  ADMIN_DASHBOARD_GOV_ROUNDS = "/admin-dashboard/gov-rounds",
  ADMIN_DASHBOARD_PARTNERSHIPS = "/admin-dashboard/partnerships",
  ADMIN_DASHBOARD_DELETED_ENTITIES = "/admin-dashboard/deleted-entities",
  ADMIN_DASHBOARD_DELETED_USE_CASES = "/admin-dashboard/deleted-use-cases",
  ADMIN_DASHBOARD_DELETED_ROUNDS = "/admin-dashboard/deleted-rounds",
  ADMIN_DASHBOARD_DELETED_GOV_ROUNDS = "/admin-dashboard/deleted-gov-rounds",
  ADMIN_DASHBOARD_DELETED_PARTNERSHIPS = "/admin-dashboard/deleted-partnerships",
  MANAGE_ADMINS = "/manage-admins",
  MISSION_STATISTICS = "/mission-statistics",
  LAUNCH_STATISTICS = "/launch-statistics",
  FUTURE_LAUNCH = "/future-launch-schedule",

  GRAPHING_TOOL = "/graphing-tool",
  GRAPHING_TOOL_ROUNDS = "/graphing-tool-rounds",
  ANALYSIS_TOOL = "/analysis-tool",
  GRAPH_EXPLORER = "/graph-explorer",
  GRAPH_EXPLORER_ENTITY = "/graph-explorer/:entityId",
  ROAD_MAP = "/roadmap",
  SUMMARY_MAP = "/map",
  HEATMAP = "/heatmap",

  MARKET_MAP = "/market-map",
  MARKET_MAP_INVESTORS = "/market-map/investors",
  MARKET_MAP_USERS = "/market-map/users",

  // QCAAS = "/qcaas",
  // QPU = "/qpu",

  QUANTUM_CLOUD_PROVIDERS = "/quantum-cloud/",
  QUANTUM_CLOUD_QPU_BENCHMARKING = "/quantum-cloud/qpu-metrics",
  QUANTUM_CLOUD_QPU_BENCHMARKING_ROADMAP = "/quantum-cloud/qpu-metrics/roadmap",
  QUANTUM_CLOUD_TERMS = "/quantum-cloud/glossary",
  QUANTUM_CLOUD_CONTACT = "/quantum-cloud/contact",

  SEARCH_ENGINE_HOME = "/news-feed",
  SEARCH_ENGINE = "/search-engine",
  ANALYSIS_GRAPH = "/analysis-graph",
  AI_SUMMARY = "/ai-summary",
  SEARCH_ENGINE_STORIES = "/stories",

  MEDIA_MONITORING = "/media-monitoring",
  MEDIA_MONITORING_ANALYSIS = "/media-monitoring/analysis",

  USE_CASE = "/use-case/:useCaseId",
  USE_CASE_NEW = "/use-case",
  USE_CASES = "/use-cases",

  BULK_UPLOAD = "/bulk-upload",

  SCRAPER_DASHBOARD_COMPANY = "/scraper-dashboard/company",
  SCRAPER_DASHBOARD_INVESTOR = "/scraper-dashboard/investor",
  SCRAPER_DASHBOARD_UNIVERSITY = "/scraper-dashboard/university",
  SCRAPER_DASHBOARD_CENTER = "/scraper-dashboard/center",
  SCRAPER_DASHBOARD_ENTERPRISE_USER = "/scraper-dashboard/enterprise-user",
  SCRAPER_DASHBOARD_GOVT_AGENCY = "/scraper-dashboard/govt-agency",
  SCRAPER_DASHBOARD_NATIONAL_LAB = "/scraper-dashboard/national-lab",
  SCRAPER_DASHBOARD_FUNDING = "/scraper-dashboard/funding",
  SCRAPER_DASHBOARD_PARTNERSHIP = "/scraper-dashboard/partnership",

  SCRAPER_DASHBOARD_COMPANY_INTEGRATED = "/scraper-dashboard/integrated/company",
  SCRAPER_DASHBOARD_INVESTOR_INTEGRATED = "/scraper-dashboard/integrated/investor",
  SCRAPER_DASHBOARD_UNIVERSITY_INTEGRATED = "/scraper-dashboard/integrated/university",
  SCRAPER_DASHBOARD_CENTER_INTEGRATED = "/scraper-dashboard/integrated/center",
  SCRAPER_DASHBOARD_ENTERPRISE_USER_INTEGRATED = "/scraper-dashboard/integrated/enterprise-user",
  SCRAPER_DASHBOARD_GOVT_AGENCY_INTEGRATED = "/scraper-dashboard/integrated/govt-agency",
  SCRAPER_DASHBOARD_NATIONAL_LAB_INTEGRATED = "/scraper-dashboard/integrated/national-lab",
  SCRAPER_DASHBOARD_FUNDING_INTEGRATED = "/scraper-dashboard/integrated/funding",
  SCRAPER_DASHBOARD_PARTNERSHIP_INTEGRATED = "/scraper-dashboard/integrated/partnership",

  // RESEARCH = "/research",
  PATENTS = "/patents",
  PATENTS_LIST_VIEW = "/patents/list",
  PATENTS_STATS = "/patents/stats",
  PATENT_DETAIL = "/patents/:patentId",

  RESEARCH_PAPERS = "/research-papers",
  RESEARCH_PAPERS_LIST_VIEW = "/research-papers/list",
  RESEARCH_PAPERS_STATS = "/research-papers/stats",

  NOT_FOUND = "/page-not-found",

  // AI Chatbot
  CHAT_BOT = "/chat-bot",
}

export default APP_ROUTES;
